<template>
  <div class="task_wrapper pointer" :class="{active: isActive, onlyTask: current && current.tasks.length == 1 && menu}">
    <template v-if="!rename_flag">
      <div v-if="!groups" class="relative">
        <div class="task left mt-3" :class="{active: isActive}" text>
          <span class="ml-6 roboto-normal-18 clr-black-38">{{task.name || "_"}}</span>
        </div>
        <img @click="menu = !menu" src="@/assets/images/components/menu-horizontal.svg" class="right mt-2 mr-6">
        <!-- <img v-if="menu" @click="menu = !menu" src="@/assets/images/components/menu-horizontal-active.svg" class="right mt-2 mr-6"> -->
        <div v-if="menu && current_task._id == task._id" class="absolute menu text-capitalize text-left" :class="{firstTask: current.tasks[0] && current.tasks[0]._id == task._id, lastTask: current.tasks[current.tasks.length-1] && current.tasks.length-1 != 0 && current.tasks[current.tasks.length-1]._id == task._id}">
          <div class="active">
            <div @click="rename" class="roboto-normal-14 clr-black-38 py-2 pl-4">Редактировать</div>
          </div>
          <div class="active">
            <DeleteItem @deleteItem="del" :task="true" :theme="false"/>
          </div>
        </div>
        <v-icon size="17" @click="toggleCompletedTask()" class="mt-4 right pointer hide-button" @mouseenter="hover = true" @mouseleave="hover = false">{{task.completed ? icons[+hover] : icons[+!hover]}}</v-icon>
      </div>
      <v-row v-else>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div class="groups">
                <v-btn class="task" :class="{active: isActive}" text>
                  <v-icon small>mdi-folder</v-icon>
                  <span>{{task.name || "_"}}</span>
                  <span class="rename_button pointer" v-if="$vuetify.breakpoint.mdAndUp" icon @click.stop="rename"><v-icon size="14">edit</v-icon></span>
                </v-btn>
                <v-btn icon small @click="deleteHeadInGroupsTasks()"><v-icon>mdi-minus-circle</v-icon></v-btn>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on }">
                    <v-btn icon small v-on="on"><v-icon> mdi-plus-box</v-icon></v-btn>
                </template>
                <v-card>
                  <div class="groups_tasks">
                    <v-subheader class="color-head">TASKS:</v-subheader>
                    <v-list-item v-for="(task, i) in current.tasks" :key="task._id">
                        <v-btn block >{{task.name}}</v-btn>
                        <v-btn small icon @click="addItemsInGroupsTasks(task)"><v-icon>mdi-plus-circle</v-icon></v-btn>
                    </v-list-item>
                    </div>
                </v-card>
              </v-dialog>
              <v-list-item  v-for="(task, i) in groupsTasks" :key="task._id">
                <v-btn block>{{task.name}}</v-btn>
                <v-btn icon small @click="deleteItemsInGroupsTasks(task)"><v-icon> mdi-minus-box</v-icon></v-btn>
              </v-list-item>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </template>
    <div v-else class="ml-6">
      <v-layout class="flex-center">
        <v-text-field @keypress.ctrl="renameOk" v-model="name" label="" required></v-text-field>
        <v-btn icon @click="renameOk" small>OK</v-btn>
      </v-layout>
    </div> 
  </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import DeleteItem from '../../popups/DeleteItem'
    export default {
        name: 'Task',
        components: {
          DeleteItem
        },
        data() {
          return {
            hover: '',
            icons: ['mdi-eye-off', 'mdi-eye'],
            rename_flag: false,
            name: '',
            dialog: false,
            menu: false,
          }
        },
        props: [
          'task',
          'groups'
        ],
        computed:{
          ...mapGetters(['current', 'current_task', 'themes']),
          isActive(){
            return this.current_task && (this.current_task._id == this.task._id)
          },
          tasks(){
            return this.current.tasks
          },
          groupsTasks() {
            const currentGroup = this.current.groups[this.current.groups.findIndex(group => group.headId == this.current_task._id)]
            return this.current.groups && this.tasks.filter(task => currentGroup && currentGroup.itemsId.some(el => el == task._id))
          }
        },
        methods:{
          ...mapMutations(['SET_CURRENT']),
          ...mapActions(['renameTask', 'delTask', 'setCompletedTask','saveOrderTasks','setRelavantNotices', 'addHeadToGroup', 'deleteHeadToGroup', 'addItemsToGroup', 'deleteItemsToGroup']),
          rename(){
            this.rename_flag = true
            this.name = this.task.name
            this.menu = false
          },
          renameOk(){
            this.renameTask({_id: this.current._id, task_id: this.task._id, name: this.name}).then(() => {
              this.rename_flag = false
            })
          },
          del(){
            this.delTask({theme_id: this.current._id, task_id: this.task._id}).then(() => {
              this.rename_flag = false
              const tasks_id = this.tasks.map(item => item._id)
              this.saveOrderTasks({tasks_id, _id: this.current._id})
              if(this.current_task._id == this.task._id){
                this.$store.dispatch('setRelavantNotices', this.tasks.filter(el => !el.completed)[0])
                this.$router.push(`/theme/${this.current.route_name}/`)
              }
            })
            this.menu = false
          },
          addHeadInGroupsTasks() {
            this.addHeadToGroup({theme: this.current, taskId: this.task._id, tasksId: []})
          },
          deleteHeadInGroupsTasks() {
            this.deleteHeadToGroup({theme: this.current, taskId: "", tasksId: []})
          },
          addItemsInGroupsTasks(task) {
            this.addItemsToGroup({theme: this.current, taskId: this.task._id, task_id: task._id})
          },
          deleteItemsInGroupsTasks(task) {
            this.deleteItemsToGroup({theme: this.current, taskId: this.task._id, task_id: task._id})
          },
          toggleCompletedTask() {
            this.setCompletedTask({_id:this.current._id, task_id: this.task._id, value: !this.task.completed})
          },
        },
    }
</script>

<style lang="scss" scoped>
    .hide-button{
        color : gray  !important;
        &:hover{
          color: black !important;
        }
    }
  .rename_button{
    opacity: 0;
  }
  .task_wrapper{
    height:46px;
    width: 100%;
    &.onlyTask {
      height:68px;
    }
    &:hover, &.active {
      background: #FFFFFF;
    }
    .menu {
      margin:-18px 0 0 23%;
      background: #FFFFFF;
      width: 158px;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
      &.firstTask {
        margin-top: 0px;
        z-index: 10;
      }
      &.lastTask {
        margin-top: -22px;
      }
      .active {
        &:hover {
          background:  #18A0FB;;
        }
      }
    }
    button.v-expansion-panel-header {
      padding: 0px;
      background-color: var(--cl-bg2);
    }
    .v-expansion-panel-content {
      background-color: var(--cl-bg2);
    }
    .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background-color: var(--cl-bg2);
    }
    &:hover{
      .rename_button{
        opacity: 1;
      }
    }    
  }
  .groups {
    margin-left: 10px;
    display: flex;
    justify-content: space-between;
  }
  .groups_tasks {
        padding: 25px 70px 25px;
        .color-head {
            background: var(--cl-bg2);
        }
        .v-subheader {
            justify-content: space-between;
        }
    } 
</style>

<style lang="scss">
 .task .v-btn__content span:first-child{
       text-transform: none !important;
 }
</style>